import { composeIO } from 'react-compose-io'
import { graficoBarraDiasIO } from './GraficoBarraDias.IO'
import { GraficoBarraDiasView } from './GraficoBarraDias.View'

export const GraficoBarraDias = composeIO(GraficoBarraDiasView, graficoBarraDiasIO)
